import * as signalR from '@microsoft/signalr';
import { IMAGE_BASE_URL } from './config';

// Only unsent changes are retained. Reconnecting must not overwrite a newer
// change from another admin with an already-delivered value from this screen.
export function createLiveBillPublisher(restaurantId, tableOtp, onPending = () => {}, factory = () =>
  new signalR.HubConnectionBuilder().withUrl(IMAGE_BASE_URL + '/tableHub', {
    accessTokenFactory: () => localStorage.getItem('Admin-API-Token') || ''
  }).withAutomaticReconnect().build()) {
  const connection = factory();
  let disposed = false, connecting = false, sending = false;
  let pending, retryTimer;
  const schedule = () => {
    if (!disposed && !retryTimer) retryTimer = setTimeout(() => { retryTimer = null; connect(); }, 2000);
  };
  const flush = async () => {
    if (disposed || sending || connection.state !== 'Connected') return;
    sending = true;
    try {
      while (pending && !disposed) {
        const change = pending;
        await connection.invoke('SendLiveBillModification', String(restaurantId).trim().toLowerCase(), String(tableOtp).trim(), change);
        if (pending === change) pending = null;
      }
    } catch (error) {
      if (!disposed) { onPending(error); schedule(); }
    } finally { sending = false; }
  };
  const connect = async () => {
    if (disposed || connecting) return;
    connecting = true;
    try {
      if (connection.state === 'Disconnected') await connection.start();
      if (disposed) { await connection.stop(); return; }
      if (connection.state === 'Connected') await flush();
      else schedule();
    } catch (error) {
      if (!disposed) { if (pending) onPending(error); schedule(); }
    } finally { connecting = false; }
  };
  connection.onreconnected(connect);
  connection.onclose(schedule);
  connect();
  return {
    publish(change) {
      if (disposed) return;
      pending = change;
      if (connection.state === 'Connected') flush();
      else { onPending(); schedule(); }
    },
    stop() {
      disposed = true;
      pending = null;
      clearTimeout(retryTimer);
      connection.stop().catch(error => console.warn('Live bill connection stop failed.', error));
    },
  };
}
